import { coreConstants } from "../constants/core.constants";

const initialState = {
  fetching: false,
  fetched: false,
  response: null,
  error: null
};

export const coreIssuers = (state = initialState, action) => {
  switch (action.type) {
    case coreConstants.GET_CORE_ISSUERS_REQUEST:
      return {
        ...state,
        fetching: true
      };
    case coreConstants.GET_CORE_ISSUERS_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        response: action.response,
        error: null
      };
    case coreConstants.GET_CORE_ISSUERS_FAILURE:
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: action.error
      };
    case coreConstants.GET_CORE_ISSUERS_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
